"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var rest_1 = __importDefault(require("../../rest"));
var customerTemplate_1 = require("../mock/customerTemplate");
var customerTemplateUrl = "".concat(process.env.CB_EMAIL_TEMPLATE_SERVICE_URL, "/customer-templates");
var CustomerTemplate = {
    getListOfCustomerTemplates: function (token, params) {
        return rest_1.default.get({
            mockFunc: customerTemplate_1.getListOfCustomerTemplates,
            url: "".concat(customerTemplateUrl, "?").concat(querystring_1.default.stringify(params)),
            token: token,
        });
    },
    getCustomerTemplate: function (token, id) {
        return rest_1.default.get({
            mockFunc: customerTemplate_1.getCustomerTemplate,
            url: "".concat(customerTemplateUrl, "/").concat(id),
            token: token,
        });
    },
    deleteCustomerTemplate: function (token, id) {
        return rest_1.default.delete({
            mockFunc: customerTemplate_1.deleteCustomerTemplate,
            url: "".concat(customerTemplateUrl, "/").concat(id),
            token: token,
        });
    },
    createCustomerTemplate: function (token, template) {
        return rest_1.default.post({
            mockFunc: customerTemplate_1.createCustomerTemplate,
            url: "".concat(customerTemplateUrl),
            token: token,
            body: template,
        });
    },
    updateCustomerTemplate: function (token, id, template) {
        return rest_1.default.put({
            mockFunc: customerTemplate_1.updateCustomerTemplate,
            url: "".concat(customerTemplateUrl, "/").concat(id),
            token: token,
            body: template,
        });
    },
    duplicateCustomerTemplate: function (token, id) {
        return rest_1.default.post({
            mockFunc: customerTemplate_1.duplicateCustomerTemplate,
            url: "".concat(customerTemplateUrl, "/duplicate/").concat(id),
            token: token,
        });
    },
    sendCustomerTemplate: function (token, body) {
        return rest_1.default.post({
            mockFunc: customerTemplate_1.sendCustomerTemplate,
            url: "".concat(customerTemplateUrl, "/send"),
            body: body,
            token: token,
        });
    },
};
exports.default = CustomerTemplate;
